import axios from '../../localAxios';
import { WorkspaceRole } from '../getWorkspaceMembers';
import { workspaceCodeURL } from '../workspacesURLs';

interface WorkspaceCode {
  code: string;
}

interface RegenerateWorkspaceCodeParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export async function regenerateWorkspaceCode({
  workspaceId,
  workspaceRole,
}: RegenerateWorkspaceCodeParams) {
  const url = workspaceCodeURL({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
  });
  const result = await axios.put<WorkspaceCode>(url.href, {
    regenerate: true,
    role: workspaceRole,
  });

  return result.data;
}
